import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";

import { UserService, AlertService } from "../_services";
import { AppGlobals } from "../app.globals";

@Component({
    templateUrl: "forgotPassword.component.html",
    styleUrls: ["forgotPassword.component.css"]
})
export class ForgotPasswordComponent implements OnInit {
    forgotPasswordForm: UntypedFormGroup;
    hide = true;

    constructor(private formBuilder: UntypedFormBuilder, private router: Router, private userService: UserService, private alertService: AlertService, private appGlobals: AppGlobals) {
    }

    ngOnInit() {
        this.appGlobals.pageTitleValue = "Forgot Password";

        this.forgotPasswordForm = this.formBuilder.group({
            username: ["", Validators.required]
        });
    }

    get f() {
        return this.forgotPasswordForm.controls;
    }

    onSubmit(submitBtn: HTMLButtonElement) {
        // stop here if form is invalid
        if (this.forgotPasswordForm.invalid) {
            return;
        }

        setTimeout(() => {
            submitBtn.disabled = true;
        }, 0);

        this.userService.forgotPassword(this.f.username.value)
            .pipe(first())
            .subscribe((result: string) => {
                if (result) {
                    this.router.navigate(["/resetPassword"], { queryParams: { type: "reset", reference: result } });
                }
                else {
                    this.alertService.showMessage("An email has been sent, please follow the link to change your password.", "Forgot Password", this.appGlobals.alertMessageTypes.success);
                    this.router.navigate(["/"]);
                }
            });
    }
}
